module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['agenda-item', {
      'agenda-item-bg-reverse': _vm.index % 2 == 0
    }]
  }, [_c('div', {
    staticClass: "item-wrap",
    class: {
      'one-width': _vm.data.speaker.length == 1 || _vm.data.speaker.length == 0, 'double-width': _vm.data.speaker.length == 2, 'triple-width': _vm.data.speaker.length == 3
    }
  }, [_c('div', {
    staticClass: "agenda-title"
  }, [_c('div', {
    staticClass: "t-name"
  }, [_c('div', [_vm._v(_vm._s(_vm.data.time.split('~')[0]))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.time.split('~')[1]))])])]), _vm._v(" "), (_vm.data.subject.split('|')[0] == '圆桌论坛') ? _c('div', {
    staticClass: "a-content"
  }, [(_vm.data.speaker[0] && _vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "name-title"
  }, [(_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('p', {
    staticClass: "bottom-title"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]) + " " + _vm._s(_vm.data.subject.split('|')[1]))])])]) : _c('div', {
    staticClass: "a-content"
  }, [(!_vm.data.speaker[0] || !_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "space"
  }) : _vm._e(), _vm._v(" "), (_vm.data.speaker[0] && _vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "name-title"
  }, [(_vm.data.speaker[0].photo) ? _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.speaker[0].photo
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "subject-type"
  }, [_vm._v(_vm._s(_vm.data.subject.split('|')[0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "subject-title"
  }, [_vm._v(" " + _vm._s(_vm.data.subject.split('|')[1]))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee337162"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgendaItem.vue
// module id = 58
// module chunks = 0